import React from 'react'
import { CgSpinner } from 'react-icons/cg'

const Loading = ({className}) => {
  return <CgSpinner className={"animate-spin text-red my-5 h-7 w-7 "+`${className}`} />;
}

export default Loading